import { render, staticRenderFns } from "./ffkf.vue?vue&type=template&id=6745d8c8&"
import script from "./ffkf.vue?vue&type=script&lang=js&"
export * from "./ffkf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports